import React from 'react';
import PropTypes from 'prop-types';
import ReadMore from './ReadMore';

const Reviews = (props) => {
	const { reviews, windowId, widgetName, labels, prefs } = props;
	const { reviewHeadingWeight, reviewHeadingCase, reviewRatingFontSize } =
		prefs;
	if (!reviews) {
		return null;
	}
	return (
		<div className="kbb-reviews mt-3">
			<ul className="list-unstyled">
				{reviews.map((review) => (
					<li key={review.reviewId} className="border-bottom py-4">
						<div className="kbb-review-item d-flex">
							<div className="kbb-review-heading-container">
								<h4
									className={`kbb-review-heading ${reviewHeadingWeight} ${reviewHeadingCase} m-0`}
								>
									{review.title}
								</h4>
								<p className="text-muted">
									{review.nickName && (
										<span>
											<span className="kbb-review-name">
												By {review.nickName}
											</span>
											<span
												className="text-muted separator"
												aria-hidden="true"
											>
												&nbsp;|&nbsp;
											</span>
											<span className="sr-only">
												{' '}
												on{' '}
											</span>
										</span>
									)}

									<span className="kbb-review-submission-date">
										{review.submissionDate}
									</span>
								</p>
							</div>
							<strong
								className={`kbb-review-rating ml-auto font-weight-bold ${reviewRatingFontSize}`}
							>
								{review.overallRating &&
									parseFloat(review.overallRating).toFixed(1)}
							</strong>
						</div>

						<ReadMore
							className="kbb-review-text"
							windowId={windowId}
							widgetName={widgetName}
							labels={labels}
						>
							{review.text}
						</ReadMore>
					</li>
				))}
			</ul>
		</div>
	);
};

Reviews.propTypes = {
	reviews: PropTypes.arrayOf(
		PropTypes.shape({
			reviewId: PropTypes.number.isRequired,
			nickName: PropTypes.string.isRequired,
			submissionDate: PropTypes.string.isRequired,
			overallRating: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired
		})
	).isRequired,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired,
	labels: PropTypes.shape({}).isRequired,
	prefs: PropTypes.shape({
		reviewHeadingWeight: PropTypes.string,
		reviewHeadingCase: PropTypes.string,
		reviewRatingFontSize: PropTypes.string
	}).isRequired
};

export default Reviews;
